import { CHANNEL_VIDEO_LIST_VALUES } from './channel-video-list-values';

export const COMPACT_SHOW_VIDEO_LIST_VALUES = {
  EXPAND_ON_CLICK: CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
  NEVER_SHOW: CHANNEL_VIDEO_LIST_VALUES.NEVER_SHOW,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/compact-show-video-list.js